import { Files } from '../../lib/constants/files'
import { Tefl } from '../../lib/types/models/tefl/tefl'
import { TeflInput } from '../../lib/types/models/tefl/tefl-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createTefl(olId: number, data: TeflInput) {
  if (data.documents)
    for (let i = 0; i < data.documents.length; i++) {
      const newFile = await uploadFile(Files.TEFL_DOCUMENT, data.documents[i])
      if (newFile) data.documents[i] = { ...newFile }
    }
  if (data.diplomas)
    for (let i = 0; i < data.diplomas.length; i++) {
      const newFile = await uploadFile(Files.TEFL_DIPLOMA, data.diplomas[i].file)
      if (newFile) data.diplomas[i].file = { ...newFile }
    }

  return restApiClient
    .url(constructApiUrl(API.tefl.create.url, { olId }))
    .post<Tefl, TeflInput>(data)
}
